import { useQuery } from '@tanstack/react-query';
import { useApiMutation } from '../../api/mutations';
import { nexusFetch } from '../../nexus/nexusClient';
import { useFixturesMode, fixtureDelay } from '../../api/fixtures';
import { flaggedFixture } from './fixture';

/**
 * Spam/Phishing-Review-Queue (#310 → nexus-Proxy #309 → mail #309).
 *   GET  /v1/admin/mail-review/flagged?level=&limit=
 *   POST /v1/admin/mail-review/flagged/:id/approve  { kind }   (Falsch-Positiv → Ham/Kein-Spam)
 *   POST /v1/admin/mail-review/flagged/:id/confirm  { kind }   (bestätigen → Junk-Move + lernen)
 */
export function useFlagged(level = 'all') {
  const fixturesMode = useFixturesMode();
  return useQuery({
    queryKey: ['nexus-mail-review', level, fixturesMode ? 'fixture' : 'live'],
    queryFn: async () => {
      if (fixturesMode) { await fixtureDelay(); return flaggedFixture(level); }
      const qs = new URLSearchParams({ limit: '100' });
      if (level && level !== 'all') qs.set('level', level);
      return nexusFetch(`/v1/admin/mail-review/flagged?${qs}`);
    },
    staleTime: 15_000,
  });
}

export function useApproveFlagged() {
  return useApiMutation({
    live: (_fetch, { id, kind }) =>
      nexusFetch(`/v1/admin/mail-review/flagged/${Number(id)}/approve`, { method: 'POST', body: { kind } }),
    fixture: () => ({ ok: true }),
    invalidate: ['nexus-mail-review'],
    successMessage: () => 'Als Falsch-Positiv freigegeben (entstuft + Absender gelernt).',
  });
}

export function useConfirmFlagged() {
  return useApiMutation({
    live: (_fetch, { id, kind }) =>
      nexusFetch(`/v1/admin/mail-review/flagged/${Number(id)}/confirm`, { method: 'POST', body: { kind } }),
    fixture: () => ({ ok: true }),
    invalidate: ['nexus-mail-review'],
    successMessage: () => 'Bestätigt (in Junk verschoben + Reputation aktualisiert).',
  });
}
